import React from 'react';
import Daily from './Daily';
import Hourly from './Hourly';
import Loader from './Loader';
import "./Weather.css";

export const WeatherIcons = {
    "01d": "icons/sunny.svg",
    "01n": "icons/night.svg",
    "02d": "icons/day.svg",
    "02n": "icons/cloudy-night.svg",
    "03d": "icons/cloudy.svg",
    "03n": "icons/cloudy.svg",
    "50n": "icons/cloudy.svg",
    "04d": "icons/perfect-day.svg",
    "04n": "icons/cloudy-night.svg",
    "09d": "icons/rain.svg",
    "09n": "icons/rain-night.svg",
    "10d": "icons/rain.svg",
    "10n": "icons/rain-night.svg",
    "11d": "icons/storm.svg",
    "11n": "icons/storm.svg",
    "50d": "icons/rain.svg",
  };
  

export default function Weather({icon,search,data,loading, cityname}) {
    
    
    return (

        <>
        
        <div className="weather">
         <div className="Location">{data===404? "No Such City Found ⚠️": ""}{data !== null && data !==404 && !loading ? '🚏' + cityname: ""}</div>

         <hr/>
        {loading ? <Loader/>: "" } 
         
         
        {data !== 404 && data !== null ? (
         
   
  
   
       <div ><center><h1 className="WeatherInfoLabel">Weather Info</h1> </center>
       <br/>
       <div className="mybg">
      <div className="WeatherInfoContainer">
            <div className="WeatherContainer">
             <div className="WeatherContainer_data">
   
                <div className="Condition"><span>{Math.round(data?.current?.temp)}°C</span> &nbsp; &nbsp;|&nbsp; &nbsp;{data?.current?.weather[0].description}
                </div>
                <div className="WeatherIcon" >
                    <div className="icons"><img src={WeatherIcons[icon]}/></div>
                </div>
             </div>

    
          <div className="weather__data">
              <div  className="humidity" ><object  className="img" data="icons/temp.svg" />{new Date(data?.current?.sunset *1000).toLocaleTimeString('en-IN')}<br/>sunset </div>
              <div className="humidity"><object  className="img"  data="icons/humidity.svg" /><span>{data?.current?.humidity}<br/>humidity</span></div>
          </div>
          <div className="weather__data">
              <div className="humidity" > <object  className="img" data="icons/wind.svg" /><span>{data?.current?.wind_speed}<br/>wind </span></div>
              <div className="humidity"> <object   className="img" data="icons/pressure.svg" /><span> {data?.current?.pressure}<br/>pressure</span></div>
          </div>
    </div>
      </div></div>
      <hr/>
      <div className="weather__forcast">
              <div className="weather__forcast__48hour">
               <Hourly data={data} icon={icon}/>
               
              </div>
              <br/>  <br/>
              <hr/>
              <div className="weather__forcast__daily">
               <Daily data={data} icon={icon} main={data?.current?.weather[0].description} />
              </div>
              <br/>  <br/>
              <hr/>
              </div>
      
             
   </div>): ""}


   </div>
  
   </>
 
    
    );
};
